// extracted by mini-css-extract-plugin
export default {"baseIcon":"Icon_baseIcon__HdZ2D"};